import Vue from 'vue'
import { io } from 'socket.io-client'
import VueSocketIOExt from 'vue-socket.io-extended'

Vue.use(VueSocketIOExt, io(process.env.VUE_APP_API_HOST_URL, { transports: ['websocket'] }))
